import 'css-chunksrc/client/pages/projectPage/calendarPage/styles.scss';export default {
  "calendarPage": "_calendarPage_1fn5p_1"
};